import styles from './tree-view.module.scss';
import MaterialTreeView from '@mui/lab/TreeView';
import MaterialTreeItem from '@mui/lab/TreeItem';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface TreeViewProps {
  children: any,
  // classes: object,
  defaultCollapseIcon?: ReactNode,
  // defaultEndIcon?: ReactNode,
  // defaultExpanded?: Array<string>,
  defaultExpandIcon?: ReactNode,
  // defaultParentIcon?: ReactNode,
  // defaultSelected?: Array<string> | string,
  // disabledItemsFocusable?: boolean,
  // disableSelection?: boolean,
  // expanded?: Array<string>,
  // id?: string,
  // multiSelect?: boolean,
  // onNodeFocus?: (event: any, value: string) => void,
  // onNodeSelect?: (event: any, nodeIds: Array<string> | string) => void,
  // onNodeToggle?: (event: any, nodeIds: any) => void,
  // selected?: Array<string> | string,
  sx?: any
}

export interface TreeItemProps {
  nodeId: string,
  children?: any,
  // classes?: object,
  // collapseIcon?: ReactNode,
  // ContentComponent?: any,
  // ContentProps?: object,
  // disabled?: boolean,
  // endIcon?: ReactNode,
  // expandIcon?: ReactNode,
  // icon?: ReactNode,
  label?: ReactNode,
  // onFocus?: any,
  // sx?: any,
  // TransitionComponent?: any,
  // TransitionProps?: object
}

export function TreeView(props: TreeViewProps) {
  return (
    <MaterialTreeView
      defaultCollapseIcon={props.defaultCollapseIcon}
      defaultExpandIcon={props.defaultExpandIcon}
      sx={props.sx}>
      {props.children}
    </MaterialTreeView>
  );
}

export function TreeItem(props: TreeItemProps) {
  return (
    <MaterialTreeItem
      nodeId={props.nodeId}
      label={props.label}>
      {props.children}
    </MaterialTreeItem>
  );
}

export default TreeView;